export default __webpack_public_path__ + "static/media/man.31a7bde1.png";